import { FEATURES } from '/src/features/_global/constants';

export const LIVE_ACTIVITY_PERMISSIONS = {
  [FEATURES.LIVE_ACTIVITY]: ({ capabilities }) => ({
    navigate: capabilities?.liveActivity.permissions.nav,
    view: capabilities?.liveActivity.permissions.view,
  }),
};
